export default __webpack_public_path__ + "static/media/marginalia-no-comments.c9e1dae6.svg";